import CertificateDetailDialog from './CertificateDetailDialog';

export default CertificateDetailDialog;
